export const addImageProcess = (src: string) => {
  return new Promise<HTMLImageElement>((resolve, reject) => {
    const img = new Image();
    img.onload = (response) => {
      resolve(img);
    };
    img.onerror = reject;
    img.src = src;
  });
};

export const addImageProcessBase64 = (src: string) => {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.crossOrigin = '*';
    img.onload = (response) => {
      const canvas: any = document.createElement('CANVAS');
      const ctx = canvas.getContext('2d');
      canvas.height = img.naturalHeight;
      canvas.width = img.naturalWidth;
      ctx.drawImage(img, 0, 0);
      // document.body.append(canvas)
      const dataURL = canvas.toDataURL('image/png');
      resolve(dataURL);
    };
    img.onerror = reject;
    img.src = src;
  });
};

export const sendGoogleEvent = (name: string, params?: any) => {
  (window as any).gtag('event', name, {
    email: (window as any).g_opt?.user?.email,
    ...params,
  });
};

export function calculateInscribedSize(originalSize: any, scaledSize: any, useOriginal: boolean) {
  if (originalSize.width === scaledSize.width && originalSize.height === scaledSize.height) {
    originalSize = {
      width: originalSize.width / 2,
      height: originalSize.height / 2,
    };
  }

  const imageSize = useOriginal ? originalSize : scaledSize;
  let zoom = 1;
  if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
    zoom = window.outerWidth / window.innerWidth;
  }
  const isMobile = window.innerWidth <= 1093;
  const windowSize = {
    width: (window.innerWidth - (isMobile ? 32 : 0)) * zoom,
    height: window.innerHeight * zoom,
  };

  // Calculate the aspect ratio of the chosen image
  const imageAspectRatio = imageSize.width / imageSize.height;

  // Calculate the maximum dimensions based on the window size
  const maxWidth = windowSize.width;
  const maxHeight = windowSize.height;

  // Calculate the maximum dimensions based on the aspect ratio
  const maxDimensions = {
    width: maxHeight * imageAspectRatio,
    height: maxWidth / imageAspectRatio,
  };

  // Choose the dimensions that fit within both the window size and maintain the aspect ratio
  const inscribedWidth = Math.min(maxWidth, maxDimensions.width, imageSize.width);
  const inscribedHeight = Math.min(maxHeight, maxDimensions.height, imageSize.height);

  // Return the inscribed image size
  return {
    width: inscribedWidth,
    height: inscribedHeight,
  };
}

export function calculatePositiveOriginalPoint(mouseLocation: any, imageSize: any, originalSize: any, inscribedImageSize: any, scaleDown: boolean) {
  const size = originalSize;
  const x = (size.width / inscribedImageSize.width) * mouseLocation.x;
  const y = (size.height / inscribedImageSize.height) * mouseLocation.y;

  return {
    x: x,
    y: y,
  };
}
